import { socket } from "./socket";

const ownerClaimCounts = new Map();

function getTotalClaims() {
  let total = 0;
  ownerClaimCounts.forEach((count) => {
    total += count;
  });
  return total;
}

export function acquireSocketConnection(ownerKey) {
  if (!ownerKey) return;
  const nextCount = (ownerClaimCounts.get(ownerKey) || 0) + 1;
  ownerClaimCounts.set(ownerKey, nextCount);

  if (!socket.connected && !socket.active) {
    socket.connect();
  }
}

export function releaseSocketConnection(ownerKey) {
  if (!ownerKey) return;
  const currentCount = ownerClaimCounts.get(ownerKey) || 0;
  if (currentCount <= 1) {
    ownerClaimCounts.delete(ownerKey);
  } else {
    ownerClaimCounts.set(ownerKey, currentCount - 1);
  }

  if (getTotalClaims() === 0 && socket.connected) {
    socket.disconnect();
  }
}

export function getSocketConnectionClaimCount() {
  return getTotalClaims();
}
